/**
* @name:巡查清单与在岗人员
* @author kk
* @date 2019/11/6
*/
<template>
  <div class="xc-person">
    <div class="xc-box">
      <div class="box-title">日巡查清单
        <img src="../../assets/images/shitang/more.png" style="float: right;cursor: pointer;" alt="" @click="checkShow(checkListNum.inspectMenuId)">
      </div>
      <div class="box-content">
        <p>未检查<span class="c3">{{checkListNum.uncheckNum || 0}}</span></p>
        <p>已检查<span class="c4">{{checkListNum.alreadyNum || 0}}</span></p>
        <p>总检查项<span class="c1">{{checkListNum.totalNum || 0}}</span></p>
      </div>
    </div>
    <div class="all-person">
      <div class="box-title">档口人员
        <img src="../../assets/images/shitang/more.png" style="float: right;cursor: pointer;" alt=""
            @click="showMore('')">
      </div>
      <div class="box-content">
        <p @click="showMore('')">共有人员<span class="c1">{{moreList.length}} 人</span></p>
        <p @click="showMore('2')">体温异常人员<span class="c2">{{tempYcNum}} 人</span></p>
        <p @click="showMore('1')">健康证即将到期<span class="c2">{{soonOverdueNum}} 人</span></p>
        <p @click="showMore('0')">健康证已到期<span class="c3">{{overdueNum}} 人</span></p>
      </div>
    </div>
    <transition name="slide-left-fade">
      <popup title="档口人员" class="people-pop" v-if="morePeople" width="775px" @closeEvent="morePeople = false">
        <div class="more-people">
          <el-radio-group class="change-status" v-model="showStatus">
            <el-radio-button :label="item.label" v-for="(item, index) in statusList" :key="index">{{item.name}}</el-radio-button>
          </el-radio-group>
          <!--即将到期人员和已到期人员-->
          <el-row>
            <el-col v-show="showStatus===p.showStatus" v-for="(p, i) in moreList" :key="i" :span="6" style="text-align:center;
            min-height: 150px">
              <div class="item-avator"><div
                  v-show="p.bodyTeperature"
                  :class="['item-avator-temp', p.teperatureStatus===0?'tem-yc':'']">{{p.bodyTeperature}}℃ {{statusFilter(p.teperatureStatus)}}</div>
                <img :src="p.fileId?imgUrl+p.fileId:avatar" alt="">
              </div>
              <el-row type="flex" justify="center">
                <span class="name">{{p.userName}}</span>
                <span :class="['status', 'status_' + p.status]" v-show="p.status !== '2'">{{p.status|filterSXkztate}}</span>
              </el-row>
              <p class="time" v-show="p.endDate">健康证{{p.endDate}}到期</p>
              <p class="time" v-show="!p.endDate">未搜索到健康证信息</p>
              <p class="time" v-show="p.teperatureTime">{{p.teperatureTime}}打卡</p>
            </el-col>
            <div class="no-the-data" style="min-height: 150px" v-show="(showStatus==='0' && overdueNum===0)">
              <div>
                <i class="iconfont icon-suoyourenyuan dzi"></i>
                <p>没有已到期人员</p>
              </div>
            </div>
            <div class="no-the-data" style="min-height: 150px" v-show="(showStatus==='1' && soonOverdueNum===0)">
              <div>
                <i class="iconfont icon-suoyourenyuan dzi"></i>
                <p>没有即将到期人员</p>
              </div>
            </div>
          </el-row>
          <!--在岗人员和体温异常-->
          <el-row>
            <el-col v-show="showStatus===p.showStatus1" v-for="(p, i) in moreList" :key="i" :span="6"
                style="text-align:center;
            min-height: 150px">
              <div class="item-avator"><div
                  v-show="p.bodyTeperature"
                  :class="['item-avator-temp', p.teperatureStatus===0?'tem-yc':'']">{{p.bodyTeperature}}℃ {{statusFilter(p.teperatureStatus)}}</div>
                <img :src="p.fileId?imgUrl+p.fileId:avatar" alt="">
              </div>
              <el-row type="flex" justify="center">
                <span class="name">{{p.userName}}</span>
                <span :class="['status', 'status_' + p.status]" v-show="p.status !== '2'">{{p.status|filterSXkztate}}</span>
              </el-row>
              <p class="time" v-show="p.endDate">健康证{{p.endDate}}到期</p>
              <p class="time" v-show="!p.endDate">未搜索到健康证信息</p>
              <p class="time" v-show="p.teperatureTime">{{p.teperatureTime}}打卡</p>
            </el-col>
            <div class="no-the-data" style="min-height: 150px" v-show="(showStatus==='2' && tempYcNum===0)">
              <div>
                <i class="iconfont icon-suoyourenyuan dzi"></i>
                <p>没有体温异常人员</p>
              </div>
            </div>
            <div class="no-the-data" style="min-height: 150px" v-show="(showStatus==='3' && onLineNum===0)">
              <div>
                <i class="iconfont icon-suoyourenyuan dzi"></i>
                <p>暂无在岗人员</p>
              </div>
            </div>
          </el-row>
          <!--所有档口人员-->
          <el-row>
            <el-col v-show="showStatus===''" v-for="(p, i) in moreList" :key="i" :span="6" style="text-align: center; min-height: 150px">
              <div class="item-avator">
                <div
                    v-show="p.bodyTeperature"
                    :class="['item-avator-temp', p.teperatureStatus===0?'tem-yc':'']">{{p.bodyTeperature}}℃ {{statusFilter(p.teperatureStatus)}}</div>
                <img :src="p.fileId?imgUrl+p.fileId:avatar" alt="">
              </div>
              <el-row type="flex" justify="center">
                <span class="name">{{p.userName}}</span>
                <span :class="['status', 'status_' + p.status]" v-show="p.status !== '2'">{{p.status|filterSXkztate}}</span>
              </el-row>
              <p class="time" v-show="p.endDate">健康证{{p.endDate}}到期</p>
              <p class="time" v-show="!p.endDate">未搜索到健康证信息</p>
              <p class="time" v-show="p.teperatureTime">{{p.teperatureTime}} 打卡</p>
            </el-col>
            <div class="no-the-data" style="min-height: 150px" v-show="showStatus==='' && moreList.length === 0">
              <div>
                <i class="iconfont icon-suoyourenyuan dzi"></i>
                <p>暂无人员</p>
              </div>
            </div>
          </el-row>
        </div>
      </popup>
    </transition>
    <transition name="slide-left-fade">
      <popup :title="'日巡查清单'+nowDate" class="people-pop" v-if="isCheckListshow" width="775px" @closeEvent="isCheckListshow = false">
        <div class="check-control">
          <el-switch
              v-model="hasCheck"
              active-text=""
              inactive-text="仅看已检查">
          </el-switch>
          <div>{{checkListNum.alreadyNum}} / {{checkListNum.totalNum-checkListNum.alreadyNum || ''}}</div>
        </div>
        <div class="check-list-box"
            v-loading="checkLoading"
            element-loading-text="数据加载中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
          <div class="check-list not-check" v-if="notCheckList && !hasCheck">
            <div class="item" v-for="(item, i) in notCheckList" :key="i">
              <div class="num">{{item.order}}.</div>
              <div class="info">
                <div class="c-content">{{item.inspectContent}}
                  <p class="pic" @click="showPic(imgUrl+item.fileId)" v-if="item.fileId.length>0">
                    <i class="el-icon-zoom-in"></i><img :src="imgUrl+item.fileId[0]" width="150px" alt=""></p>
                  <p style="color:#00b7ee" v-if="item.remark">{{item.remark}}</p></div>
                <div class="c-name" v-if="item.modifier">{{item.modifier}} {{item.modifyTime}} 提交</div>
              </div>
              <div class="status">未检查</div>
            </div>
          </div>
          <div class="check-line"><i class="el-icon-caret-bottom"></i>已检查 <span class="c-l"></span></div>
          <div class="check-list">
            <div class="item" v-for="(item, i) in checkList" :key="i">
              <div class="num">{{item.order}}.</div>
              <div class="info">
                <div class="c-content">{{item.inspectContent}}
                  <p class="pic" @click="showPic(imgUrl+item.fileId)" v-if="item.fileId.length>0">
                    <i class="el-icon-zoom-in"></i><img :src="imgUrl+item.fileId[0]" width="150px" alt=""></p>
                  <p style="color:#00b7ee" v-if="item.remark">{{item.remark}}</p></div>
                <div class="c-name" v-if="item.modifier">{{item.modifier}} {{item.modifyTime}} 提交</div>
              </div>
              <div class="status">已检查</div>
            </div>
            <div class="no-the-data" style="min-height: 150px" v-show="checkList.length === 0">
              <div>
                <i class="iconfont icon-suoyourenyuan dzi"></i>
                <p>暂无已检查项目</p>
              </div>
            </div>
          </div>
        </div>
      </popup>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'xcPerson',
    data () {
      return {
        morePeople: false,
        isCheckListshow: false,
        deptId: this.$route.query.deptId,
        imgUrl: this.$store.getters.fileApi,
        avatar: require('../../assets/images/avatar.jpg'),
        moreList: [],
        showStatus: '',
        statusList: [
          {
            name: '全部',
            label: ''
          },
          {
            name: '今日在岗',
            label: '3'
          },
          {
            name: '体温异常',
            label: '2'
          },
          {
            name: '即将到期',
            label: '1'
          },
          {
            name: '已到期',
            label: '0'
          }
        ],
        statusVal: '-1',
        checkList: '',
        notCheckList: '',
        checkListNum: '',
        overdueNum: 0, // 过期人员
        soonOverdueNum: 0, // 即将过期人员
        tempYcNum: 0, // 体温异常人员
        onLineNum: 0, // 在岗人员
        nowDate: '',
        hasCheck: false,
        checkLoading: false
      }
    },
    props: {
      contractorId: {}
    },
    watch: {
      contractorId (cur) {
        if (cur === '') return
        this.contractorId = cur
        this.getDayListNum()
        this.getAllPerson(cur)
        this.isCheckListshow = false
      }
    },
    mounted () {
      this.initDate()
      this.getAllPerson(this.contractorId)
      this.getDayListNum()
      window.getPersonWebsock = () => {
        this.getAllPerson(this.contractorId)
      }
      this.$nextTick(() => {
        document.addEventListener('click', (e) => {
          if (e.target.className === 'point') {
            this.morePeople = false
            this.isCheckListshow = false
            this.showStatus = ''
          }
        })
      })
    },
    methods: {
      /**
       * @Description: 初始化时间
       * @author kk
       * @date 2019/11/7
       */
      initDate () {
        let date = new Date()
        this.nowDate = this.$utils.formatTime({date}).date
      },
      /**
       * @Description: 判断人员状态
       * @author kk
       * @param num 人员状态
       * @date 2019/11/5
       */
      statusFilter (num) {
        switch (num) {
          case 0:
            return '异常'
          case 1:
            return '正常'
          default:
            return '未打卡'
        }
      },
      /**
       * @Description: 获取巡查清单
       * @author kk
       * @date 2019/11/6
       */
      getDayListNum () {
        let params = {
          departmentId: this.deptId,
          orgId: this.contractorId
        }
        this.$request.inspectmenuDeptGet(params).then(res => {
          console.log('获取巡查清单', res)
          this.checkListNum = res
        }).catch(e => {
          console.log(e, 'eeeeeeeeeeeeeeeeeeeeee')
        })
      },
      /**
       * @Description: 获取在岗人员
       * 体温状态（0-异常 1-正常 2-未打卡）
       * @author kk
       * @date 2019/11/6
       */
      getAllPerson (contractorId) {
        let params = {
          departmentId: this.deptId,
          contractorId: contractorId
        }
        this.$request.employeeOnpostDeptcontraListGet(params).then(res => {
          console.log('根据食堂编号获取在岗人员', res)
          this.moreList = []
          this.overdueNum = 0
          this.soonOverdueNum = 0
          this.tempYcNum = 0
          this.onLineNum = 0
          if (!this.$utils.isEmptyObject(res)) {
            this.moreList = res
            res.map(v => {
              if (v.status === '0') {
                this.$set(v, 'showStatus', v.status)
                this.overdueNum++
              } else if (v.status === '1') {
                this.$set(v, 'showStatus', v.status)
                this.soonOverdueNum++
              }
              if (v.teperatureStatus === 0) {
                this.$set(v, 'showStatus1', '2')
                this.tempYcNum++
              } else if (v.teperatureStatus === 1) {
                this.$set(v, 'showStatus1', '3')
                this.onLineNum++
              }
            })
          }
        }).catch((e) => {
          console.error(e)
        })
      },
      /**
       * @Description: 显示更多在岗人员
       * @author kk
       * @date 2019/11/6
       */
      showMore (status) {
        // this.getAllPerson(this.contractorId)
        if (this.statusVal === status) {
          this.morePeople = !this.morePeople
        } else {
          this.morePeople = true
        }
        this.isCheckListshow = false
        this.showStatus = status
        this.statusVal = status
      },
      /**
       * @Description: 显示日巡查清单
       * @author kk
       * @param id
       * @date 2019/11/7
       */
      checkShow (id) {
        if (this.checkListNum.totalNum) {
          this.isCheckListshow = !this.isCheckListshow
          if (this.isCheckListshow) this.hasCheck = false
          this.morePeople = false
          this.checkList = []
          this.notCheckList = []
          this.checkLoading = true
          this.$request.inspectmenuItemListGet({inspectMenuId: id}).then(res => {
            console.log(res, 'eeeeeeeeeeee')
            res.list.map((v, i) => {
              this.$set(res.list[i], 'order', i + 1)
              if (v.dayInspectFlag === 0) {
                this.notCheckList.push(v)
              } else {
                this.checkList.push(v)
              }
            })
          }).catch(e => {
            console.log(e, 'eeeeeeeeeeee')
          }).finally(() => {
            this.checkLoading = false
          })
        }
      },
      /**
       * @Description: 显示图片框
       * @author kk
       * @param item
       * @date 2019/11/7
       */
      showPic (item) {
        this.$superMessage('查看图片', '', {imgPic: item, btnShow: false}).then(() => {
        }).catch(() => {
        })
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  .xc-person {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

    .change-status {
      position: absolute;
      top: 20px;
      right: 60px;

      .el-radio-button__inner {
        background: #06263a;
        color: #0ba3d4;
        padding: 6px 15px;
        border: 1px solid #146496;
      }

      .el-radio-button:first-child .el-radio-button__inner {
        border-left: 1px solid #146496;
      }

      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #1a6abd;
        color: #fff;
      }
    }

    .box-title {
      height: 35px;
      font-size: 16px;
      color: #fff;
      padding-left: 5px;
      padding-top: 3px;
    }

    .box-content {
      padding: 0 5px;

      span {
        float: right;
      }

      p {
        line-height: 24px;
        color: #00aaf1;
        cursor: pointer;
      }
    }

    .xc-box {
      width: 48%;
      background-color: rgba(8, 129, 143, .1);
      padding: 5px;
    }

    .all-person {
      width: 48%;
      background-color: rgba(8, 129, 143, .1);
      padding: 5px;
    }

    .popup-wraps {
      background-color: #003055;
    }

    .check-control {
      padding: 0 10px 10px;
      display: flex;
      justify-content: space-between;
      position: absolute;
      width: 728px;
      background: #003055;

      .el-switch__label {
        color: #3f9eff;
      }
    }

    .check-list-box {
      margin-top: 30px;

      .check-line {
        color: #06ff00;
        font-size: 18px;
        margin: 20px 0;

        i {
          margin: 0 10px;
        }

        .c-l {
          background-color: rgba(6, 255, 0, .3);
          display: inline-block;
          height: 2px;
          width: 85%;
          margin-bottom: 4px;
          margin-left: 10px;
        }
      }

      .check-list {
        .item {
          display: flex;
          font-size: 14px !important;
          background-color: rgba(8, 129, 143, .1);
          margin-bottom: 10px;
          padding: 10px 8px;

          .num {
            width: 5%;
            font-size: 20px;
            color: #fff;
          }

          .info {
            width: 85%;

            .c-content {
              line-height: 30px;
              word-break: break-all;

              .pic {
                position: relative;
                width: 200px;
                text-align: center;
                overflow: hidden;
                cursor: pointer;

                i {
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  font-size: 24px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  color: #fff;
                  background: rgba(0, 0, 0, 0.6);
                  opacity: 0;
                }
              }

              .pic:hover i {
                opacity: 1;
              }

            }

            .c-name {
              color: #a5afb7;
            }
          }

          .status {
            width: 10%;
            color: #06ff00;
            font-size: 14px;
            text-align: center;
            height: 30px;
            line-height: 25px;
          }
        }
      }

      .not-check {
        .item {
          background-color: #042741 !important;

          .status {
            width: 10%;
            color: #ff9000;
            text-align: center;
            height: 30px;
            line-height: 25px;
            font-size: 14px;
            background-color: rgba(8, 129, 143, .1);
          }
        }
      }

    }
  }

  .c1 {
    color: #00fffc
  }

  .c2 {
    color: #ffea00
  }

  .c3 {
    color: #ff9f3c
  }

  .c4 {
    color: #00ff41
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/xclistPerson.vue